interface SpinnerProps {
  /**
   * Pixel size of the spinner. Defaults to 14px which sits comfortably
   * inline with text-xs / text-sm button labels.
   */
  size?: number;
  /**
   * Tailwind text-color class controlling the spinner color (it inherits
   * currentColor from the SVG). Defaults to currentColor — so passing
   * `text-white` on the parent button is enough; this prop is for
   * overrides.
   */
  className?: string;
}

/**
 * Spinner — small inline loading indicator used inside buttons during
 * async actions. P3.4 polish (Ernie 2026-05-03): replaces the previous
 * "just dim the button" pattern with an actual spinning indicator so
 * users can see something is happening, not assume the tap was ignored.
 *
 * SVG-only, no animation library — uses a Tailwind `animate-spin` class
 * which is built in (no config needed).
 */
export function Spinner({ size = 14, className = '' }: SpinnerProps) {
  return (
    <svg
      role="status"
      aria-label="Loading"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      className={`animate-spin ${className}`}
    >
      <circle
        cx="12"
        cy="12"
        r="10"
        stroke="currentColor"
        strokeWidth="3"
        opacity="0.25"
      />
      <path
        d="M12 2 a10 10 0 0 1 10 10"
        stroke="currentColor"
        strokeWidth="3"
        strokeLinecap="round"
      />
    </svg>
  );
}
